import { render, staticRenderFns } from "./voiceList.vue?vue&type=template&id=52439ba9&"
import script from "./voiceList.vue?vue&type=script&lang=js&"
export * from "./voiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52439ba9')) {
      api.createRecord('52439ba9', component.options)
    } else {
      api.reload('52439ba9', component.options)
    }
    module.hot.accept("./voiceList.vue?vue&type=template&id=52439ba9&", function () {
      api.rerender('52439ba9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/voice/voiceList.vue"
export default component.exports